export default {"src":"/_next/static/media/largeWarningIcon.35f4667c.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};